import ProductDescription from "./ProductDescription";
import React, { useEffect } from "react";
import { applyPageMeta, machineMeta } from "../seo/pageMeta";
import { Link, useLocation, useParams } from "react-router-dom";
import useFetch from "../Network/useFetch";
import ProductVideo from "./ProductVideo";
import MachinePhotoGallery from "./MachinePhotoGallery";
import { MACHINE_VIDEOS } from "./productVideos";
import "../gaming-experience.css";
export const GameProductDetail = () => {
  const { gamingId } = useParams();
  // Back to the page of the machine list the customer came from.
  const fromList = (useLocation().state as any)?.machinesReturn;
  const listLink = typeof fromList === "string" && /^\/gaming-machines(\?page=\d{1,4})?#machines$/.test(fromList) ? fromList : "/gaming-machines";
  const { data, isLoading, isError, refetch } = useFetch(
    `${
      process.env.REACT_APP_SERVER_URL
    }/product/gaming-machine/${encodeURIComponent(gamingId || "")}`,
    ["GAMING", gamingId]
  );
  const machine = data?.data?.game;
  useEffect(() => {
    applyPageMeta(`/game-product-detail/${gamingId}`, machine?.name ? machineMeta(machine) : { title: "Gaming machine" });
  }, [machine, gamingId]);
  if (isLoading)
    return (
      <main className="gm-wrap gm-builder">
        <p role="status">Loading gaming machine…</p>
      </main>
    );
  if (isError || !machine)
    return (
      <main className="gm-wrap gm-builder">
        <h1>Gaming machine unavailable</h1>
        <p>
          We couldn’t load this gaming machine. Try again, or browse all gaming machines.
        </p>
        <button onClick={() => refetch()}>Try again</button>
        <Link to="/gaming-machines">Browse machines</Link>
      </main>
    );
  return (
    <main className="gm-wrap gm-builder">
      <Link className="gm-back" to={listLink}>
        ← All gaming machines
      </Link>
      <div className="gm-detail-grid">
        <MachinePhotoGallery
          key={machine._id || gamingId}
          name={machine.name}
          mainImage={machine.mainImage}
          image={machine.image}
        />
        <section>
          <p className="gm-eyebrow">GAMING MACHINE</p>
          <h1>{machine.name}</h1>
          <ProductDescription text={machine.description} />
          <p className="gm-note">
            Game/theme: {machine.name}. Hardware can be discussed without
            changing the game.
          </p>
          {Array.isArray(machine.features) && machine.features.length > 0 && (
            <>
              <h2>Key features</h2>
              <ul>
                {machine.features.map((s, i) => (
                  <li key={i}>{s}</li>
                ))}
              </ul>
            </>
          )}
          {Array.isArray(machine.specifications) &&
            machine.specifications.length > 0 && (
              <>
                <h2>Specifications</h2>
                <ul>
                  {machine.specifications.map((s, i) => (
                    <li key={i}>{s}</li>
                  ))}
                </ul>
              </>
            )}
          <div className="gm-card-actions">
            <Link
              className="gm-primary"
              to={`/build-your-machine?machine=${encodeURIComponent(
                machine._id || gamingId || ""
              )}`}
            >
              Customise this machine →
            </Link>
            <Link
              to={`/build-your-machine?machine=${encodeURIComponent(
                machine._id || gamingId || ""
              )}`}
            >
              Request a quote
            </Link>
          </div>
          <p>
            Availability, hardware compatibility, installation, and pricing are
            confirmed by quotation.
          </p>
        </section>
      </div>
      <ProductVideo video={MACHINE_VIDEOS[machine._id || gamingId || ""]} />
    </main>
  );
};
